import { FlexColumn, FlexRowCenter } from "designSystem/index";
import React, { FunctionComponent } from "react";
import TableChartOptions from "../../csi/middleware/customView/options/TableChartOptions";
import TablePrintOptions from "../../csi/middleware/customView/options/TablePrintOptions";
import TableViewOptions from "../../csi/middleware/customView/options/TableViewOptions";
import SecondaryDisplayViewOptions from "./SecondaryDisplayViewOptions";

const SecondaryDisplayOptionsTab: FunctionComponent = function SecondaryDisplayOptionsTab() {
	return (
		<FlexRowCenter>
			<FlexColumn width="100%">
				<SecondaryDisplayViewOptions />
				<TableViewOptions />
				<TableChartOptions />
				<TablePrintOptions />
			</FlexColumn>
		</FlexRowCenter>
	);
};

export = SecondaryDisplayOptionsTab